/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentDetail } from '../../models/agent-detail';

export interface GetAgent$Params {

/**
 * ID agenta
 */
  id: number;
}

export function getAgent(http: HttpClient, rootUrl: string, params: GetAgent$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentDetail>> {
  const rb = new RequestBuilder(rootUrl, getAgent.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentDetail>;
    })
  );
}

getAgent.PATH = '/admin/agents/{id}';
